import React from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../App/Components/TabbedView/TabbedView";
import ResultsTablePage from "./Components/Tabs/ResultsTable/ResultsTablePage";
import FeaturedAdResultsPage from "./Components/Tabs/FeaturedAdResults/FeaturedAdResultsPage";

function ResultsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);

  const tabs = [
    { title: "Results Table", component: <ResultsTablePage /> },
    { title: "Featured Ad Results", component: <FeaturedAdResultsPage /> },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">{selectCareersClient.shortName} Results</h1>
        <div className={classes.root}>
          <TabbedView tabs={tabs} />
        </div>
      </div>
    </>
  );
}

export default ResultsPage;
